import React, { Fragment } from 'react'
import {
  Grid,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import {
  DataColumnSettings,
  DataGridSettings
} from '../../interfaces/DataGrid/DataGridSettings'

interface DataGridColumnProps {
  datafield: string
  settings: DataGridSettings
  children?: React.ReactNode
}

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      fontWeight: 'bold'
    },
    text: {
      padding: 0,
      margin: 0
    }
  })
)

export const DataGridColumn: React.FC<DataGridColumnProps> = ({
  children,
  datafield,
  settings
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))
  const column = settings.columns.find((col) => col.dataField === datafield)
  const titleElement = (column: DataColumnSettings): JSX.Element => {
    return !matchesLG ? (
      <Typography
        className={`${classes.title} ${classes.text}`}
        variant='body2'
        component='p'
      >
        {column.title}
      </Typography>
    ) : (
      <Fragment />
    )
  }
  return column ? (
    <Grid
      item
      xs={column.xs}
      sm={column.sm || column.xs}
      lg={column.lg || column.sm || column.xs}
      justifyContent="center"
      alignContent="center"
      alignItems="center"
    >
      <Grid item>{titleElement(column)}</Grid>
      <Grid item>{children}</Grid>
    </Grid>
  ) : (
    <Grid item>{children}</Grid>
  )
}
